// src/components/dashboard/GroupCard.jsx

import React from 'react';
import { COLORS } from '../../constants';

export default function GroupCard({ name, passed, total, doaCount = 0 }) {
  const noData = total === 0;
  const pctVal = noData ? 0 : Math.round((passed / total) * 100);
  const barColor = noData ? COLORS.slate : pctVal === 100 ? COLORS.success : pctVal >= 70 ? COLORS.warning : COLORS.danger;

  return (
    <div style={{ background: COLORS.surface, border: `1px solid ${COLORS.line}`, borderRadius: 12, padding: '12px 14px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center', marginBottom: 8 }}>
        <span
          style={{
            fontSize: 12,
            fontWeight: 800,
            color: noData ? COLORS.muted : COLORS.text,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {name}
        </span>

        <span style={{ fontSize: 12, fontWeight: 800, color: COLORS.textSecondary, flexShrink: 0 }}>
          {noData ? '—' : `${passed}/${total}`}
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ flex: 1, height: 6, background: COLORS.line, borderRadius: 20, overflow: 'hidden' }}>
          <div
            style={{
              width: `${pctVal}%`,
              height: '100%',
              background: barColor,
              borderRadius: 20,
              transition: 'width 0.4s ease',
            }}
          />
        </div>

        <span style={{ minWidth: 34, textAlign: 'right', fontSize: 11, fontWeight: 800, color: barColor }}>
          {pctVal}%
        </span>
      </div>

      {doaCount > 0 && (
        <div
          style={{
            marginTop: 8,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            background: COLORS.dangerLight,
            color: COLORS.danger,
            borderRadius: 20,
            padding: '4px 8px',
            fontSize: 10,
            fontWeight: 800,
          }}
        >
          ⚠️ {doaCount} DOA
        </div>
      )}
    </div>
  );
}